module.exports = __webpack_public_path__ + "img/icon_map_4_hg.3a16baf8.png";